<template>
  <AppDeleteModal
    :loading="isLoading"
    :show="showConfirmDeleteDialog"
    :title="$t('action.remove')"
    keypath="action.remove_from_dashboard"
    @on-confirm="onConfirmDeleteDashboard"
    @on-close="closeConfirmDeleteDialog"
  >
    <template #i18n-t:elementName>
      {{ elementForDelete.name }}
    </template>

    <template #i18n-t:customDashboardName>
      {{ customDashboardName }}
    </template>

    <template #app-dialog:confirm-btn-text>
      {{ $t('action.remove') }}
    </template>
  </AppDeleteModal>
</template>

<script setup>
import { ref } from 'vue'

import CustomDashboardApiHandler from '@/api/custom-dashboard'
import { handleError } from '@/utils/error-handling'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

defineOptions({
  name: 'RemoveCustomDashboardElement'
})

const props = defineProps({
  showConfirmDeleteDialog: {
    type: Boolean
  },

  elementForDelete: {
    type: Object,
    default: () => ({})
  },

  customDashboardName: {
    type: String,
    default: ''
  }
})
const isLoading = ref(false)

const emit = defineEmits(['close', 'confirm', 'on-success'])

const closeConfirmDeleteDialog = () => {
  emit('close')
}
const onConfirmDeleteDashboard = async () => {
  const customDashboardApi = new CustomDashboardApiHandler()
  try {
    const { id, dashboardId, moduleId } = props.elementForDelete
    isLoading.value = true
    await customDashboardApi.removeElementFromModule({
      elementId: id,
      dashboardId,
      moduleId
    })
    closeConfirmDeleteDialog()
    emit('on-success')
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped></style>
